import { Injectable } from '@angular/core';
import { IUserCustomSetting } from '@app/shared/models/settings.model';
import { COUNTRY, SCOPE } from '@shared/types/enums';
import { BehaviorSubject } from 'rxjs';

import { AppContext } from './app.context.service';
import { IClearContext } from './interface/iclear-context.interface';

@Injectable({
  providedIn: 'root',
})
export class UserContext implements IClearContext {
  private readonly _scopes$ = new BehaviorSubject<SCOPE[]>([]);
  public scopes$ = this._scopes$.asObservable();

  private readonly _roles$ = new BehaviorSubject<string[]>([]);
  public roles$ = this._roles$.asObservable();

  private readonly _wentThroughAccessLevelCheck$ = new BehaviorSubject<boolean>(false);
  public wentThroughAccessLevelCheck$ = this._wentThroughAccessLevelCheck$.asObservable();

  private readonly _configurations$ = new BehaviorSubject<IUserCustomSetting[]>([]);
  public configurations$ = this._configurations$.asObservable();

  constructor(private readonly _appCtx: AppContext) {}

  setScopes(scopes: SCOPE[]): void {
    this._scopes$.next(scopes);
  }

  getScopes(): SCOPE[] {
    return this._scopes$.getValue();
  }

  setRoles(roles: string[]): void {
    this._roles$.next(roles);
  }

  getRoles(): string[] {
    return this._roles$.getValue();
  }

  setWentThroughAccessLevelCheck(value: boolean): void {
    this._wentThroughAccessLevelCheck$.next(value);
  }

  wentThroughAccessLevelCheck(): boolean {
    return this._wentThroughAccessLevelCheck$.getValue();
  }

  setConfigurations(configs: IUserCustomSetting[]) {
    this._configurations$.next(configs);
  }

  configurations(): IUserCustomSetting[] {
    return this._configurations$.getValue();
  }

  userHasAccessToCountries(countries: COUNTRY[]): boolean {
    //return true;
    //FIXME ver como podemos hacer para no tener que llamar el servicio de contexto de cliente acá
    return countries.includes(this._appCtx.getCountry() || ''); //&& this.userContext?.availableCountries.some(i => countries.includes(i))) || false;
  }

  userHasOperation(operation: string): boolean {
    return this.getScopes().findIndex(value => value === operation) !== -1;
  }

  clear(): void {
    this._scopes$.next([]);
  }
}
